import React from "react";

export function SummaryStat({ label, value, tone, testid }) {
  const tones = {
    ok: "text-emerald-300 border-emerald-500/20 bg-emerald-500/5",
    warn: "text-amber-300 border-amber-500/20 bg-amber-500/5",
    bad: "text-red-300 border-red-500/20 bg-red-500/5",
  };
  return (
    <div
      data-testid={testid}
      className={`px-3 py-2 rounded-lg border ${tones[tone] || tones.ok}`}
    >
      <p className="text-[10px] uppercase tracking-wide opacity-70">{label}</p>
      <p className="text-lg font-bold mt-0.5">{value}</p>
    </div>
  );
}
